import styled from "@emotion/styled";
import {  Form, Input } from "antd";
import React, { FC } from "react";

interface ProductNameFormProps {
  is_active: boolean;
}

const ProductNameForm: FC<ProductNameFormProps> = ({ is_active }) => {
  return (
    <FormWrapper>
      <Form.Item
        label="ชื่อสินค้า"
        name="name"
        rules={[{ required: true, message: "กรุณากรอกชื่อสินค้า" }]}
      >
        <Input
          placeholder="กรุณากรอกชื่อสินค้า"
          showCount
          maxLength={120}
          size="small"
        />
      </Form.Item>
    </FormWrapper>
  );
};

export default ProductNameForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
`;
